import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import Cta from "../../components/en/CtaWebsite";

import "../../styles/common.css";
import "../../styles/service.css";

import imgIssue01 from "../../img/website/illustration_website_01.svg";
import imgIssue02 from "../../img/website/illustration_website_02.svg";
import imgIssue03 from "../../img/website/illustration_website_03.svg";
import imgIssue04 from "../../img/website/illustration_website_04.svg";
import imgfeature01 from "../../img/website/img_feature_01.png";
import imgfeature02 from "../../img/website/img_feature_02.png";
import imgfeature03 from "../../img/website/img_feature_03.png";
import imgSupport01 from "../../img/website/img_support_01.png";
import imgSupport02 from "../../img/website/img_support_02.png";
import imgSupport03 from "../../img/website/img_support_03.png";

const WebSiteEn = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='website'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Website Development</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">Website Development</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className="title">
            <p className='title-lead'>ISSUE</p>
            <h2>We solve these issues</h2>
          </div>
          <div className='flexBox-bkWhite issue-box'>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue01} alt="" />
              </div>
              <h3>Enhance corporate image in Europe</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue02} alt="" />
              </div>
              <h3>Clearly convey the strengths of products and companies</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue03} alt="" />
              </div>
              <h3>Aim to acquire inquiries via the web</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue04} alt="" />
              </div>
              <h3>Sell products through e-commerce</h3>
            </div>
          </div>
          <div className='issue-text'>
            <p>LOGOT will create a website that maximizes your <br /><span>“presence”</span> by addressing these issues.</p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>Features of websites created by LOGOT</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>Build an e-commerce site with diverse payment options and flexible product registration</h3>
                <p className='feature-item__detail'>Successful online shops require highly flexible e-commerce site construction.<br />LOGOT's e-commerce sites can handle unlimited products and scale flexibly.<br />We also support e-commerce site construction using Shopify, accommodating diverse payment systems.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>Maximize business potential with flexible e-commerce site construction</h3>
                <p className='feature-item__detail'>Website design influences the first impression of a company, significantly impacting the number of inquiries.<br />LOGOT creates websites that are stylish, unique, and trendy, tailored to your needs, and propose designs that win over your target audience.</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>Website development with localization and multilingual support</h3>
                <p className='feature-item__detail'>Language barriers are one of the biggest challenges when entering or expanding in the European market.<br />LOGOT can create websites that support multiple languages.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>Corporate website development process</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>Free consultation (via Zoom or in-person)</h3>
                <p>We will ask about your business content, management status, website development purpose, and budget. For those considering website development for the first time, we strive to provide easy-to-understand explanations without using technical terms. We also welcome customers considering a renewal of their existing site.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>Submission of quotation</h3>
                <p>Based on the content of the hearing, we will consider your company's branding strategy through the website. We will create a quotation based on the website structure plan. We also offer branding support and corporate logo creation.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>Contract</h3>
                <p>We will provide you with a quotation. If you have any questions or concerns, please ask our sales team. We will thoroughly explain each item in detail. Once you are satisfied with the content, the formal contract will be concluded through electronic contract.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>Kick-off meeting</h3>
                <p>We will hold a meeting to share the production policy and concept of the website. We will delve into your company overview, product information, and strengths of your products, aligning the image of your site with ours.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>5</p></div>
              <div className='flow-box__text'>
                <h3>Start of production</h3>
                <p>Based on the opinions and requests heard at the kick-off meeting, we will start website production. We will ask for your cooperation in providing the necessary materials and information for manuscript creation.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>6</p></div>
              <div className='flow-box__text'>
                <h3>Report on production progress</h3>
                <p>After starting production, we will report on the production progress at the following timings:</p>
                <ol className='list-cercleNumber'>
                  <li>
                    <span>&#9312;</span>
                    <h4>Submission of TOP design proposal</h4>
                    <p>We will propose a design centered on the first view of the TOP page. This will be an alignment of the overall design policy of the site.</p>
                  </li>
                  <li>
                    <span>&#9313;</span>
                    <h4>Submission of test site (PC)</h4>
                    <p>Based on the TOP page design, we will build the entire site. You will also check the text, movements, and illustrations together.</p>
                  </li>
                  <li>
                    <span>&#9314;</span>
                    <h4>Submission of test site (smartphone)</h4>
                    <p>Based on the PC version site, we will build the smartphone version site. Please inform the person in charge of any corrections or requests.</p>
                  </li>
                </ol>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>7</p></div>
              <div className='flow-box__text'>
                <h3>Delivery (live launch)</h3>
                <p>We will conduct a double-check of the entire website by the quality control team. After thoroughly checking the text, design, movements, and flow, the site will be launched. For one week after the site is launched, we will handle minor corrections such as text corrections free of charge.</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='support'>
          <div className="title">
            <p className='title-lead'>SUPPORTS</p>
            <h2>Post-launch operational support</h2>
          </div>
          <div className='support-text'>
            <p>Corporate sites that don't end with the launch!</p>
          </div>
          <div className='flexBox-bkWhite support-box'>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport01} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>Leave the website operation to us!</h3>
                <p>We support sales expansion and brand recognition with strategies optimized for the target market.<br />Through SEO measures, SNS operation, advertising operation, and inquiry acquisition measures, we accelerate web customer acquisition in the European market.</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/en/marketing">Learn more</a>
              </div>
            </div>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport02} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>It's the era where corporate impressions are determined by "branding"</h3>
                <p>We provide total branding support that maximizes your company's brand value, from strategy formulation to visual design, content creation, and data analysis.<br />LOGOT continuously supports you to enhance your brand value in the long term while responding to market changes.</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/en/branding">Learn more</a>
              </div>
            </div>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport03} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>Continuous support with consulting! "Customer Success (Maintenance and Operation Support)"</h3>
                <p>We assist with "successful web customer acquisition" through regular strategic consulting based on access data and answering questions about update methods.</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/en/branding">Learn more</a>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default WebSiteEn